// extracted by mini-css-extract-plugin
export default {"root":"BaseUserIcon_root__d3J0G"};